import React from 'react';
import { connect } from 'react-redux';

import classes from './FilterLayover.scss';
import * as flightsActions from '../../../store/actions/index';

const flightLayovers = ['0h-5h', '5h-10h', '10h-15h', '15h+'];

const filterLayover = (props) => {
    return (
        <ul className={classes.LayoverList}>
            {flightLayovers.map((layover, index) => (
                <li onClick={(e) => props.onFilterByLayoverTime(index)} className={[classes.LayoverListItem, props.layoversActive.includes(index) ? classes.LayoverListItemActive : null].join(' ')} key={index}>
                    {layover}
                </li>
            ))}
        </ul>
    );
}

const mapStateToProps = state => {
    return {
        layoversActive: state.flights.selectedLayovers,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onFilterByLayoverTime: (timeIndex) => dispatch(flightsActions.filterByLayoverTime(timeIndex)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(filterLayover);


// WEBPACK FOOTER //
// ./src/components/Filters/FilterLayover/FilterLayover.js